import React, { Component, Suspense } from 'react'
import { Form, Input, Select } from 'antd'
import { compose } from 'recompose'
import { get } from 'lodash'
import InfoTooltip from '../../../elements/InfoTooltip'
import CenterSpin from '../../../elements/CenterSpin'

const EditorContAsync = React.lazy(() => import('../../../elements/EditorCont'))
const Option = Select.Option

class EmailForm extends Component {
  render() {
    const { getFieldDecorator } = this.props.form
    const { email, files, onChange, onSelect, onKeydown, template } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 21, offset: 1 },
      },
    }

    return (
      <Form layout={'horizontal'}>
        <Form.Item {...formItemLayout} label={'To'}>
          {getFieldDecorator('to', {
            initialValue: get(email, 'to'),
            rules: [{ required: true, message: 'To Can\'t be Empty!' }],
          })(<Input placeholder={'To'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'CC'}>
          {getFieldDecorator('cc', {
            initialValue: get(email, 'cc'),
          })(<Input placeholder={'CC'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'BCC'}>
          {getFieldDecorator('bcc', {
            initialValue: get(email, 'bcc'),
          })(<Input placeholder={'BCC'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'From'}>
          {getFieldDecorator('from', {
            initialValue: get(email, 'from'),
            rules: [{ required: true, message: 'From Can\'t be Empty!' }],
          })(<Input disabled={true} placeholder={'From'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'Subject'}>
          {getFieldDecorator('subject', {
            initialValue: get(email, 'subject'),
            rules: [{ required: true, message: 'Subject Can\'t be Empty!' }],
          })(<Input placeholder={'Subject'} />)}
        </Form.Item>
        <Suspense fallback={<CenterSpin />}>
          <Form.Item {...formItemLayout} label={'Body'}>
            <EditorContAsync
              value={template}
              change={onChange}
              select={onSelect}
              keydown={onKeydown}
            />
          </Form.Item>
        </Suspense>
        <Form.Item
          style={{ color: 'rgba(0, 0, 0, 0.65)' }}
          {...formItemLayout}
          label={
            <InfoTooltip
              title={
                'If desired file not listed make sure to upload them to relevant document files tab and check the email property.'
              }
              value={'Attachments'}
            />
          }>
          {getFieldDecorator('attachments', {
            initialValue: get(email, 'attachments'),
          })(
            <Select mode='multiple' placeholder='Select Attachments'>
              {files.map(f => (
                <Option key={f.uuid || f.file || f.uid}>{f.name}</Option>
              ))}
            </Select>,
          )}
        </Form.Item>
      </Form>
    )
  }
}

EmailForm.propTypes = {}
EmailForm.defaultProps = {}

export default compose(Form.create())(EmailForm)
